"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
var Actions_1 = __importDefault(require("./Actions"));
var lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
var useWidth_1 = __importDefault(require("../../util/useWidth"));
var PaginationWithEnd = function (props) { return (react_1.default.createElement(Actions_1.default, __assign({}, props))); };
var PaginationWithoutEnd = function (props) { return (react_1.default.createElement(Actions_1.default, __assign({}, props, { showEndPages: false }))); };
var emptyArray = [];
var defaultRowsPerPageOptions = [5, 10, 25, 100];
var useAccumulatePerPageOptions = function (initialOptions, perPage) {
    var initialSet = (0, react_1.useMemo)(function () { return new Set(initialOptions); }, []);
    var accumulatePerPagesSet = (0, react_1.useRef)(initialSet);
    return (0, react_1.useMemo)(function () {
        initialOptions.forEach(function (option) {
            return accumulatePerPagesSet.current.add(option);
        });
        if (typeof perPage === "number") {
            accumulatePerPagesSet.current.add(perPage);
        }
        return Array.from(accumulatePerPagesSet.current).sort(function (a, b) { return a - b; });
    }, [initialOptions, perPage]);
};
var Pagination = function (props) {
    var total = props.total, perPage = props.perPage, setPage = props.setPage, page = props.page, setPerPage = props.setPerPage, _a = props.rowsPerPageOptions, _rowsPerPageOptions = _a === void 0 ? defaultRowsPerPageOptions : _a, showSmall = props.showSmall, maxExactTotalCount = props.maxExactTotalCount;
    var rowsPerPageOptions = useAccumulatePerPageOptions(_rowsPerPageOptions, perPage);
    var width = (0, useWidth_1.default)();
    var rppId = (0, react_1.useMemo)(function () { return (0, lodash_uniqueid_1.default)("rowsPerPage"); }, []);
    var mediumRPPLabelId = (0, react_1.useRef)(rppId);
    var nbPages = (0, react_1.useMemo)(function () { return Math.ceil(total / perPage) || 1; }, [total, perPage]);
    (0, react_1.useEffect)(function () {
        if (page < 1 || isNaN(page)) {
            setPage(1);
        }
    }, [page]);
    var handlePageChange = (0, react_1.useCallback)(function (event, page) {
        if (event) {
            event.stopPropagation();
        }
        if (page < 0 || page > nbPages - 1) {
            throw new Error("Page number ".concat(page + 1, " out of boundaries"));
        }
        setPage(page + 1);
    }, [nbPages, page, setPage]);
    var handlePerPageChange = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        event.stopPropagation();
        setPerPage(typeof event.target.value === "string"
            ? parseInt(event.target.value, 10)
            : event.target.value);
    }, [setPerPage]);
    var beyondMaxExactTotalCount = Boolean(maxExactTotalCount && total > maxExactTotalCount);
    var labelDisplayedRows = (0, react_1.useCallback)(function (_a) {
        var from = _a.from, to = _a.to, count = _a.count, page = _a.page;
        return "".concat(from, "-").concat(to, " of ").concat(beyondMaxExactTotalCount && maxExactTotalCount
            ? Math.max(to, maxExactTotalCount) + "+"
            : count);
    }, [beyondMaxExactTotalCount, maxExactTotalCount]);
    var PaginationComponent = (0, react_1.useMemo)(function () {
        // if we are not on/near the final page, and beyondMaxExactTotalCount, don't show the final pages.
        if (!beyondMaxExactTotalCount ||
            page === nbPages - 1 ||
            page === nbPages - 2 ||
            page === nbPages - 3) {
            return PaginationWithEnd;
        }
        return PaginationWithoutEnd;
    }, [beyondMaxExactTotalCount, page, nbPages]);
    if (total === 0) {
        return null;
    }
    var small = (react_1.default.createElement(TablePagination_1.default, { count: total, rowsPerPage: perPage, page: page - 1, onPageChange: handlePageChange, rowsPerPageOptions: emptyArray, component: "span", labelDisplayedRows: labelDisplayedRows, backIconButtonProps: {
            "aria-label": "previous page",
        }, nextIconButtonProps: {
            "aria-label": "next page",
        }, SelectProps: {
            onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
            },
            MenuProps: {
                style: { zIndex: 100000 },
            },
        } }));
    var medium = (react_1.default.createElement(TablePagination_1.default, { count: total, rowsPerPage: perPage, page: page - 1, onPageChange: handlePageChange, onRowsPerPageChange: handlePerPageChange, ActionsComponent: PaginationComponent, component: "span", 
        // In the near future we should be able to use labelId={this.mediumRPPLabelId}
        // for now it causes an annoying proptype error...
        labelRowsPerPage: react_1.default.createElement("span", { id: mediumRPPLabelId.current }, "Rows per page:"), labelDisplayedRows: labelDisplayedRows, rowsPerPageOptions: rowsPerPageOptions, SelectProps: __assign({ onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
            }, MenuProps: {
                style: { zIndex: 100000 },
            }, SelectDisplayProps: {
                "aria-describedby": mediumRPPLabelId.current,
            } }, props.SelectProps) }));
    return showSmall || width === "xs" ? small : medium;
};
exports.default = Pagination;
//# sourceMappingURL=index.js.map